/* eslint-disable */
const _load = url => {
  return new Promise ((resolve, reject) => {
    const Img = new Image();
    Img.src = url;
    Img.onload = e => resolve(url);
    Img.onerror = e => {
      console.warn(`img load error: => '${url}'`);
      reject();
    }
  });
};
const config = {
  bg (el, binding) {
    let { url, defaultUrl } = binding.value;
    el.style.backgroundImage = `url(${defaultUrl})`;
    if (!url) return;
    _load(url).then(res => {
      el.style.backgroundImage = `url(${res})`;;
    }).catch((err) => {
      console.error(err)
    });
  },
  src (el, binding) {
    let { url, defaultUrl } = binding.value;
    el.src = defaultUrl;
    if (!url) return;
    _load(url).then(res => {
      el.src = res;
    }).catch(() => {});
  }
};

export default Vue => {
  for (let item in config) {
    Vue.directive(item, config[item]);
  }
};



// WEBPACK FOOTER //
// ./src/filters/directive.js